export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11421.d8e1bb05.jpg";